import React from 'react';


const GeneralText = ({ generalText }) =>  (
  <h6 className="m-5 font-normal">{generalText}</h6>
);

export default GeneralText;
